<script>
export default {
  name: 'BlockRtTimer',
  components: {},
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      time: 0,
      initTime: 0,
      timeOver: false,
      countDownInterval: null,
    }
  },
  computed: {
    seconds: function () {
      //  minutes = ('0' + minutes).substr(-2)
      // seconds = ('0' + seconds).substr(-2)
      return ('0' + Math.floor(this.time % 60)).substr(-2)
    },
    minutes: function () {
      return ('0' + Math.floor(this.time % 3600 / 60)).substr(-2)
    },
    hours: function () {
      return ('0' + Math.floor(this.time % (3600 * 24) / 3600)).substr(-2)
    },
    days: function () {
      return ('0' + Math.floor(this.time / (3600 * 24))).substr(-2)
    },
  },
  watch: {
    timeOver: 'emitTimeOver',
  },
  created () {
    this.time = this.componentData.time
    this.doCountDown()
  },
  beforeDestroy () {
    clearInterval(this.countDownInterval)
  },
  methods: {
    doCountDown () {
      this.countDownInterval = setInterval(
        function () {
          this.decreaseTime()
        }.bind(this),
        1000
      )
    },
    decreaseTime () {
      return this.time > 0
        ? (this.time = this.time - 1)
        : (this.timeOver = true)
    },
    emitTimeOver () {
      clearInterval(this.countDownInterval)
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <p :class="$style.container__copie">{{ $t('COMMON.WAIT_TIME') }}</p>
    <div :class="$style.container__slots">
      <div :class="$style.container__slot">
        {{ days }}
        <p :class="$style.container__slot__date">
          {{ $t('COMMON.DAYS') }}
        </p>
      </div>
      <div :class="$style.container__slot">
        {{ hours }}
        <p :class="$style.container__slot__date">
          {{ $t('COMMON.HOURS') }}
        </p>
      </div>
      <div :class="$style.container__slot">
        {{ minutes }}
        <p :class="$style.container__slot__date">
          {{ $t('COMMON.MINUTES') }}
        </p>
      </div>
      <div :class="$style.container__slot">
        {{ seconds }}
        <p :class="$style.container__slot__date">
          {{ $t('COMMON.SECONDS') }}
        </p>
      </div>
    </div>
  </div>
</template>


<style scoped lang="scss" module>
@import '@design';

.container {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  height: 4rem;
  margin: 1rem 0;
  padding: 0.5rem;
  background-color: $color-rt-yellow-background;

  /* border-radius: 8px; */
  box-shadow: $regular-box-shadow;

  &__copie {
    @extend %typography-medium;

    color: $color-rt-yellow-copie;
    width: 30%;
  }

  &__slots {
    width: 70%;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    align-items: center;
  }

  &__slot {
    @extend %typography-large;

    color: $color-rt-yellow-copie;
    text-align: center;

    &__date {
      @extend %typography-xsmall;

      font-weight: 600;

      color: $color-rt-yellow-copie;
    }
  }
}
</style>
